import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=af929038&scoped=true"
import script from "./HospitalList.vue?vue&type=script&lang=js"
export * from "./HospitalList.vue?vue&type=script&lang=js"
import style0 from "./HospitalList.vue?vue&type=style&index=0&id=af929038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af929038",
  null
  
)

export default component.exports